module.exports = __webpack_public_path__ + "assets/img/user.a0ef8f70.png";